import { SetStateAction } from 'react';
import { useNavigate } from 'react-router-dom';

import { UserInfoType } from '../../../common/type/UserInfoType';
import { responseType } from '../../../common/type/ResponseType';
import { permission } from '../../../common/const/commonConst';

import { registerHandler } from '../../feature/handler/registerHandler';
import { G500LiteAuthInfoType, OffsegAuthInfoType } from '../../feature/type/AuthInfoType';

type InputType = {
	setIsAsyncProcess: (value: SetStateAction<boolean>) => void;
	isChecked: boolean;
	offsegLoginAuthInfo: OffsegAuthInfoType;
	offsegReregistrationAuthInfo: OffsegAuthInfoType;
	g500LiteRegistrationAuthInfo: G500LiteAuthInfoType;
	g500LiteReregistrationAuthInfo: G500LiteAuthInfoType;
	isReregistrationDialogStep2Opened: boolean;
	setUserInfo: React.Dispatch<React.SetStateAction<UserInfoType>>;
	setIsRegistrationError: (value: React.SetStateAction<boolean>) => void;
	setIsLocalStorageError: (value: React.SetStateAction<boolean>) => void;
};

/**
 * G500Liteログイン情報登録カスタムフック
 */
export const usePostRegister = (input: InputType) => {
	const navigate = useNavigate();

	const { setIsAsyncProcess, isChecked, offsegLoginAuthInfo, offsegReregistrationAuthInfo, g500LiteRegistrationAuthInfo, g500LiteReregistrationAuthInfo, isReregistrationDialogStep2Opened, setUserInfo, setIsRegistrationError, setIsLocalStorageError } = input;

	// ログイン情報登録ボタンを押下した際の処理
	const onClickRegister = async () => {
		setIsAsyncProcess(true);

		const offsegAuthInfo = (isReregistrationDialogStep2Opened) ? offsegReregistrationAuthInfo : offsegLoginAuthInfo;
		const g500LiteAuthInfo = (isReregistrationDialogStep2Opened) ? g500LiteReregistrationAuthInfo : g500LiteRegistrationAuthInfo;
		const [responseNum, permissionNum] = await registerHandler(offsegAuthInfo, g500LiteAuthInfo, isChecked, setUserInfo);

		setIsAsyncProcess(false);
		setIsRegistrationError(false);
		setIsLocalStorageError(false);

		switch (responseNum) {
			case responseType.success:
				if (permissionNum === permission.id.driver) {
					navigate('/car-use-result');
					return;
				}

				navigate('/current-car-place');
				return;

			case responseType.notExistApiResponseData:
				setIsRegistrationError(true);
				return;

			case responseType.apiError:
				setIsRegistrationError(true);
				return;

			case responseType.dbError:
				setIsRegistrationError(true);
				return;

			case responseType.systemError:
				setIsRegistrationError(true);
				return;

			case responseType.validationError:
				setIsRegistrationError(true);
				return;

			case responseType.WebStorageError:
				setIsLocalStorageError(true);
				return;
		}
	};
	return { onClickRegister };
};
